import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const optionsApi = createApi({
    reducerPath: 'options',
    baseQuery: createBaseQueryWithReauth('/options'),

    tagTypes: ['Options'],

    endpoints: builder => ({

        getOptions: builder.query({
            query: (shop_id) => ({
                url: `/list${shop_id ? `?shop_id=${shop_id}` : ''}`,
                method: 'GET',
            }),
            providesTags: ['Options'],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            refetchOnFocus: true,
            refetchOnReconnect: true,
        }),

        createOption: builder.mutation({
            query: ({ shop_id, ...data }) => ({
                url: `/create?shop_id=${shop_id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Options'],
        }),

        updateOption: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/update?id=${id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Options'],
        }),

        deleteOption: builder.mutation({
            query: (id) => ({
                url: `/delete?id=${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['Options'],
        }),

        toggleOptionStatus: builder.mutation({
            query: (id) => ({
                url: `/toggle-status?id=${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['Options'],
        }),
    }),
});

export const {
    useGetOptionsQuery,
    useCreateOptionMutation,
    useUpdateOptionMutation,
    useDeleteOptionMutation,
    useToggleOptionStatusMutation,
} = optionsApi;